import { subjectNameKey } from "./dedupeSubjects";

function subjectClassId(sub) {
    if (!sub) return "";
    if (sub.classId) return String(sub.classId);
    const cls = sub.sclassName;
    if (cls && typeof cls === "object") return String(cls._id || cls.id || "");
    if (typeof cls === "string") return cls;
    return "";
}

function teacherSubjectRows(teacher) {
    if (Array.isArray(teacher?.teachSubjects) && teacher.teachSubjects.length) {
        return teacher.teachSubjects;
    }
    if (teacher?.teachSubject?.subName) return [teacher.teachSubject];
    return [];
}

/** Map subject id / normalized name → { teacherId, teacherName } for one class. */
export function buildClassSubjectTeacherMap(teachers, classId) {
    const byName = new Map();
    const byId = new Map();
    if (!classId || !Array.isArray(teachers)) return { byName, byId };

    const cid = String(classId);
    for (const teacher of teachers) {
        const teacherName = String(teacher?.name || "").trim();
        const teacherId = teacher?._id || teacher?.id;
        if (!teacherName || !teacherId) continue;

        for (const sub of teacherSubjectRows(teacher)) {
            if (subjectClassId(sub) !== cid) continue;
            const sid = String(sub._id || sub.id || "").trim();
            const key = subjectNameKey(sub.subName);
            const entry = {
                teacherId: String(teacherId),
                teacherName,
                teacher: { _id: teacherId, id: teacherId, name: teacherName },
            };
            if (sid) byId.set(sid, entry);
            if (key && !byName.has(key)) byName.set(key, entry);
        }
    }
    return { byName, byId };
}

export function applyClassSubjectTeacherMap(subject, map) {
    if (!subject || !map) return subject;
    if (subject?.teacher?.name || subject?.teacherName) return subject;

    const sid = String(subject._id || subject.id || "").trim();
    const key = subjectNameKey(subject.subName);
    const hit = (sid && map.byId.get(sid)) || (key && map.byName.get(key));
    if (!hit) return subject;

    return {
        ...subject,
        teacherId: hit.teacherId,
        teacherName: hit.teacherName,
        teacher: hit.teacher,
    };
}

export function enrichSubjectsWithClassTeachers(subjects, teachers, classId) {
    if (!Array.isArray(subjects) || !subjects.length) return subjects || [];
    const map = buildClassSubjectTeacherMap(teachers, classId);
    return subjects.map((s) => applyClassSubjectTeacherMap(s, map));
}
